import {Link} from "react-router-dom";

export const NotFound = () => {
  return (
    <div>
      <h2>Not found</h2>
      <p>
        <Link to="/">Go to the home</Link>
      </p>
    </div>
  );
}